import {Routes, Route, Navigate} from "react-router-dom";
import GalleryPage from "./pages/GalleryPage";
import {useEffect, useState} from "react";
import {
    buildGalleriesRepository,
    buildPhotosRepository,
    GalleriesRepository
} from "./lib/galleriesRepository";
import {ResolvedGallery} from "./types";

export default function App() {
    const emptyGalleries: GalleriesRepository = new GalleriesRepository(new Map<string, ResolvedGallery>());
    const [galleriesRepository, setGalleriesRepository] = useState<GalleriesRepository>(emptyGalleries);

    useEffect(() => {
        console.log("Loading galleries...");
        (async () => {
            const pRep = await buildPhotosRepository();
            const gRep = await buildGalleriesRepository(pRep);
            setGalleriesRepository(gRep);
        })().catch(console.error);
    }, []);

    return (
        <>
            <Routes>
                <Route path="/" element={<Navigate to="/galleries" replace/>}/>
                <Route path="/galleries" element={<GalleryPage galleriesRepository={galleriesRepository}/>}/>
                {/* Gallery by id */}
                <Route path="/g/:id" element={<GalleryPage galleriesRepository={galleriesRepository}/>}/>
                {/* Specific photo open in lightbox (filename is URL-encoded) */}
                <Route path="/g/:id/p/:photo" element={<GalleryPage galleriesRepository={galleriesRepository}/>}/>
                {/* Fallback */}
                <Route path="*" element={<Navigate to="/galleries" replace/>}/>
            </Routes>
        </>
    );
}
